import { z } from 'zod'

export const YearMonth = z.string().regex(/^[0-9]{4}-[0-9]{2}$/)
